import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ConsentPageRoutingModule } from './consent-routing.module';
import { ConsentPage } from './consent.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ConsentPageRoutingModule,
    ComponentsModule,
  ],
  declarations: [ConsentPage],
})
export class ConsentPageModule {}
